import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SelectorService {
  private subjectChangedGroup = new Subject<string>();
  public currentGroup$ = this.subjectChangedGroup.asObservable();

  emitGroupChange(id: string) {
    this.subjectChangedGroup.next(id);
  }
}
